module.exports = __webpack_public_path__ + "media/src/images/icons/info-18ad08b88da4334fc343d014151ee41a.svg";